module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253037695_Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfa",
    attrs: {
      "id": "int"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253037695_Introduction"
    }
  }, [_vm._v("Introduction: The Cartographic Imperative")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253037695_Part_1"
    }
  }, [_c('b', [_vm._v("Part I: Place in Geocritical Theory and Practice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_1"
    }
  }, [_c('b', [_vm._v("1")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Topophrenia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Introducing Geocriticism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Geocritical Situations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253037695_Part_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part II: Spatial Representation in Narrative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Mise en Abyme of Literary Cartography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Space of the Novel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Theatrum Geographicum")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "pt3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253037695_Part_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part III: Fantasy and the Spatial Imagination")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Adventures in Literary Cartography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("In the Suburbs of Amaurotum")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _c('span', {
    staticClass: "spacec"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Beyond the Flaming Walls of the World")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocfa",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: A Map of the Pyrenees")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfa",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253037695_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84a4d6c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253037695_Contents.vue
// module id = 72
// module chunks = 0